module.exports = __webpack_public_path__ + "img/15.b39a74d3.jpg";